import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import classes from "./LoginPage.module.css";
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import SmallLoader from '../components/Loaders/SmallLoader';
import OTPInput from "react-otp-input";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { setUserToken } from '../store/slices/userTokenSlice';
import { v4 as uuidv4 } from 'uuid';
import { login } from '../http/http';
import SubscribeModal from '../components/SubscribeModal';
import TermsModal from '../components/TermsModal';
import Lottie from 'lottie-react';
import snowfallAnimation from "../animations/snowfall-animation.json";
import starsAnimation from "../animations/starsAnimation.json";
import wordAnimation from "../animations/guessWordAnimation.json";
import gridAnimation from "../animations/gridAnimation.json";

const LoginPage = () => {
    const [msisdn, setMsisdn] = useState("");
    const [loginLoading, setLoginLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [extRef, setExtRef] = useState(null);
    const { userToken } = useSelector(state => state.persisted.userTokenSlice);
    const [modal, setModal] = useState(false);
    const [termsModal, setTermsModal] = useState(false);

    useEffect(() => {
        if (userToken) {
            navigate("/home");
        }
    }, [userToken]);

    const { t } = useTranslation();

    useEffect(() => {
        if (searchParams.get("ext_id")) {
            setExtRef(searchParams.get("ext_id"));
        } else {
            setSearchParams({ ext_id: uuidv4() });
        }
    }, [searchParams]);
    const handleFormSubmission = async (e) => {
        try {
            e.preventDefault();
            if (msisdn?.trim().length == 0) {
                return;
            }
            // if (msisdn.length < 9) {
            //     toast.error("Please Enter a Valid Sri Lanka Mobile Number!");
            //     return;
            // }
            setLoginLoading(true);
            await login({ msisdn: msisdn })
                .then((res) => {
                    setLoginLoading(false);
                    dispatch(setUserToken(res?.data?.result?.token));
                    navigate("/home");
                    toast.success(t("84"));
                })
                .catch((err) => {
                    setLoginLoading(false);
                    if (err?.response?.data?.error?.status == 0) {
                        setModal(true);
                    }
                    else if (err?.response?.data?.error?.status == 1) {
                        navigate("/low-balance");
                    }
                    else {
                        toast.error(t("86"));
                    }
                });
        } catch (error) {
            toast.error(t("86"));
        }
    }
    return (
        <>
            <Header />

            <div className={classes.container}>
                {/* <h1 className={classes.heading}>
                    {t("57")} <span style={{ color: '#e63946' }}>QuizMaster</span> {t("59")}
                </h1> */}

                <h1 className={classes.heading}>
                    <span style={{ color: '#3550dc' }}>Quiz Masters</span>{" "}{t("59")}
                </h1>

                {/* add the zip game ui here */}

                {/* <div className={classes.word_game_container}>
                    <div className={classes.word_game_sub_container}>
                        <Lottie animationData={starsAnimation} loop autoPlay className={classes.animation_stars} />
                    </div>

                    <div className={classes.grid_animation_container}>
                        <Lottie animationData={gridAnimation} loop autoPlay className={classes.grid_animation} />
                    </div>

                    <div className={classes.photo_container}>
                        <Lottie animationData={wordAnimation} loop autoPlay className={classes.photo} />
                    </div>

                    <div className={classes.word_game_content}>
                        <h1 className={classes.word_game_heading}>Zip Game
                        </h1>
                        <p className={classes.word_game_text}>Just For Fun</p>
                        <button type="button" className={classes.word_play_btn}
                            onClick={() => {
                                navigate("/zip-game-details")
                            }}
                        >
                            Play Now
                        </button>
                    </div>
                </div> */}

                <div className={classes.word_game_container}>
                    <div className={classes.word_game_sub_container}>
                        <Lottie
                            animationData={starsAnimation}
                            loop
                            autoPlay
                            className={classes.animation_stars}
                        />
                    </div>

                    <div className={classes.grid_animation_container}>
                        <Lottie
                            animationData={gridAnimation}
                            loop
                            autoPlay
                            className={classes.grid_animation}
                        />
                    </div>

                    <div className={classes.photo_container}>
                        <Lottie
                            animationData={wordAnimation}
                            loop
                            autoPlay
                            className={classes.photo}
                        />
                    </div>

                    <div className={classes.word_game_content}>
                        <p className={classes.word_game_badge}>FREE GAME</p>
                        <h1 className={classes.word_game_heading}>Zip Game</h1>
                        <p className={classes.word_game_text}>
                            Play for free and get the chance to win rewards
                        </p>

                        <button
                            type="button"
                            className={classes.word_play_btn}
                            onClick={() => navigate("/register/zip-game")}
                        >
                            Play for Free
                        </button>
                    </div>
                </div>

                <div className={classes.actions_box_container}>
                    <div className={classes.actions_box}>
                        <button className={`${classes.action_box} ${classes.active}`}
                            type='button'
                        >
                            {t("60")}
                        </button>
                        <button className={`${classes.action_box}`}
                            onClick={() => navigate(`/?ext_id=${extRef}`)}
                        >
                            {t("61")}
                        </button>
                    </div>
                </div>

                <form className={classes.form} onSubmit={handleFormSubmission}
                >
                    <div className={classes.username_field_form}>
                        <div className={classes.country_code}>
                            <img src="/assets/images/flag.png" alt="flag" className={classes.flag} />
                            <p className={classes.country_code_number}>+230</p>
                        </div>
                        <input
                            id="msisdn"
                            name="msisdn"
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            autoFocus placeholder={t("62")} className={classes.input_field_username}
                            onChange={(e) => {
                                setMsisdn(e.target.value)
                            }}
                            value={msisdn}
                        />
                    </div>

                    <div className={classes.check_box_container}>
                        <input type="checkbox" id="terms" name="Terms & Conditions" value="Terms"
                            className={classes.check_box} checked
                        >
                        </input>
                        <label for="terms" className={classes.check_box_label}>
                            {t("98")}{" "}<span className={classes.link} onClick={() => setTermsModal(true)}>{t("114")}</span>
                        </label>
                    </div>



                    <button type="submit"
                        disabled={loginLoading}
                        className={classes.login_btn}>{
                            loginLoading ? <SmallLoader style={{ border: "5px solid #fff" }} /> : t("60")
                        }</button>

                    <div className={classes.footer}>
                        <p><span>&copy;</span>  Rainboo Softmate {new Date().getFullYear()}</p>
                    </div>
                </form>

            </div>

            {modal && <SubscribeModal setModal={setModal} />}
            {termsModal && <TermsModal setTermsModal={setTermsModal} />}
        </>
    )
}

export default LoginPage